export default "__VITE_ASSET__CRR6$Zst__"